import React, { useEffect, useState } from 'react';
import axios from 'axios';

// Ustawienie FIRMY (wybiera administrator w Ustawieniach -> Moje konto): ktory numer zamowienia pokazywac
// w Wiadomosciach / Issues / Zwrotach (apilo | ok | base). Jedno zapytanie na sesje strony (wspolna pamiec podreczna).
type Src = 'apilo' | 'ok' | 'base';
let cache: Src | null = null;
let pending: Promise<Src> | null = null;
const listeners: Array<(v: Src) => void> = [];
const norm = (v: any): Src => (v === 'ok' || v === 'base' ? v : 'apilo');

export function loadOrderNumberSource(force?: boolean): Promise<Src> {
  if (cache && !force) return Promise.resolve(cache);
  if (pending && !force) return pending;
  pending = axios.get('/api/ok-crm/prefs')
    .then((r: any) => { cache = norm(r.data && r.data.order_number_source); listeners.forEach((f) => f(cache as Src)); return cache as Src; })
    .catch(() => { cache = 'apilo'; return 'apilo' as Src; })
    .finally(() => { pending = null; });
  return pending;
}

export function setOrderNumberSourceCache(v: Src) {
  cache = norm(v);
  listeners.forEach((f) => f(cache as Src));
}

export function useOrderNumberSource(): Src {
  const [v, setV] = useState<Src>(cache || 'apilo');
  useEffect(() => {
    listeners.push(setV);
    loadOrderNumberSource().then(setV);
    return () => { const i = listeners.indexOf(setV); if (i >= 0) listeners.splice(i, 1); };
  }, []);
  return v;
}

const copy = (t: string) => { try { navigator.clipboard.writeText(t); } catch (e) { /* ignore */ } };
const LABEL: Record<Src, string> = { apilo: 'Apilo', ok: 'OK', base: 'Base' };
const COLOR: Record<Src, string> = { apilo: '#6d28d9', ok: '#15803d', base: '#0369a1' };

// Numer zamowienia przy pozycji zamowienia klienta (Wiadomosci / Issues): Apilo, OPENkontakt albo Base.
export function OrderNoBadge({ o }: { o: any }) {
  const src = useOrderNumberSource();
  const val = !o ? '' : src === 'ok' ? (o.ok_number || '') : src === 'base' ? (o.base_id || '') : (o.apilo_id || '');
  if (!val) return null;
  return <span title="Kliknij, aby skopiować" onClick={() => copy(String(val))} style={{ cursor: 'pointer' }}>{LABEL[src]}: <b style={{ color: COLOR[src] }}>{String(val)}</b></span>;
}

// Linia "Zamowienie ..." w Zwrotach.
export function OrderNoLine({ apilo, ok, base }: { apilo?: string | null; ok?: string | null; base?: string | null }) {
  const src = useOrderNumberSource();
  const val = src === 'ok' ? ok : src === 'base' ? base : apilo;
  if (!val) return null;
  return (
    <div style={{ fontSize: 12, color: '#111827', marginBottom: 8 }}>
      {'Zamówienie ' + (src === 'ok' ? 'OK' : LABEL[src]) + ': '}
      <b style={{ fontFamily: 'monospace', cursor: 'pointer' }} title="Kliknij, aby skopiować" onClick={() => copy(String(val))}>{val}</b>
    </div>
  );
}
